import React, { useEffect, useState } from "react";
import {
  suggestedComponentOf,
  lucideNameOf,
  isLucideIcon,
  loadIconMap,
} from "./launcherIcons";

/**
 * Renders a Lucide icon by its stored "lucide:Name" value.
 *
 * The suggested icons render immediately. Anything else needs the full library,
 * which is a lazily-loaded chunk — so this falls back to the placeholder for a
 * moment rather than blocking the page on it.
 */
export default function LauncherGlyph({ value, size = 22, fallback = null }) {
  const Suggested = suggestedComponentOf(value);
  const [Loaded, setLoaded] = useState(null);

  const needsLibrary = !Suggested && isLucideIcon(value);

  useEffect(() => {
    if (!needsLibrary) {
      setLoaded(null);
      return undefined;
    }

    let cancelled = false;

    loadIconMap().then((iconMap) => {
      if (cancelled) return;
      setLoaded(() => iconMap[lucideNameOf(value)] || null);
    });

    return () => {
      cancelled = true;
    };
  }, [value, needsLibrary]);

  const Icon = Suggested || Loaded;

  if (!Icon) return fallback;

  return <Icon size={size} strokeWidth={1.9} />;
}
